<div class="header-bloc register" *ngIf="step !== 2">
  <div class="btn-return-b">
    <button class="return-btn" (click)="onBackClick()"></button>
    <h1>{{ 'REGISTER_PAGE.TITLE' | translate}}</h1>
  </div>
  <h3 *ngIf="step === 0">{{ 'REGISTER_PAGE.SUBTITLE_TYPE' | translate}}</h3>
  <h3 *ngIf="step !== 0 && selectedRole === 'particulier'">
    {{ 'REGISTER_PAGE.SUBTITLE' | translate}}
  </h3>
  <h3 *ngIf="step !== 0 && selectedRole === 'prestataire'">
    {{ 'REGISTER_PAGE.JOIN_US' | translate}}
  </h3>
  <p class="obligatoir" *ngIf="step != 0">
    {{'REGISTER_PAGE.REQUIRED_INPUTS'|translate}}
  </p>
</div> 